(function () {
  const form = document.getElementById(`product_form_${AddOnPrinting.productId}`)
  form.addEventListener("submit", (evt) => {
    const thisForm = evt.currentTarget
    const checkbox = thisForm.elements['addPrinted']
    if (!checkbox.checked) {
      return
    }

    const addPrinting = document.createElement("input")
    addPrinting.type = "hidden"
    addPrinting.name = "items[][id]"
    addPrinting.value = AddOnPrinting.printVariantId

    const printingNote = document.createElement("input")
    printingNote.type = "hidden"
    printingNote.name = "items[][properties][Print-for-pattern]"
    printingNote.value = AddOnPrinting.productName

    form.appendChild(addPrinting)
    form.appendChild(printingNote)
  })
})();